import { render } from "./Globe.vue?vue&type=template&id=cb2f0b8a"
import script from "./Globe.vue?vue&type=script&lang=js"
export * from "./Globe.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "cb2f0b8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb2f0b8a', script)) {
    api.reload('cb2f0b8a', script)
  }
  
  module.hot.accept("./Globe.vue?vue&type=template&id=cb2f0b8a", () => {
    api.rerender('cb2f0b8a', render)
  })

}

script.__file = "src/icons/components/filled/Globe.vue"

export default script